<template>
  <div>
    <v-overlay
      v-if="loading"
      :value="loading"
      absolute
      opacity="0.2"
      z-index="1"
    >
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <template v-else>
      <grid-layout
        v-if="$vuetify.breakpoint.mdAndUp"
        :layout="layout"
        :col-num="colNum"
        :cols="{ lg: colNum, md: colNum, sm: colNum, xs: colNum, xxs: colNum }"
        :row-height="rowHeight"
        :is-resizable="false"
        :is-mirrored="false"
        :vertical-compact="true"
        :margin="margin"
        :responsive="true"
        :auto-size="true"
        :use-css-transforms="true"
        @layout-updated="saveLayout"
      >
        <grid-item
          v-for="widget in layout"
          :x="widget.x"
          :y="widget.y"
          :w="widget.w"
          :h="widget.h"
          :i="widget.i"
          :key="widget.i"
          :is-draggable="true"
          dragAllowFrom=".v-toolbar__title"
        >
          <Widget v-if="widget.item" :widget="widget"></Widget>
        </grid-item>
      </grid-layout>
      <v-row v-else>
        <v-col
          v-bind:key="`widget_${widget.i}`"
          cols="12"
          v-for="widget in layoutSorted"
        >
          <Widget v-if="widget.item" :widget="widget"></Widget>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import VueGridLayout from "vue-grid-layout";
import Widget from "./Widget";

export default {
  name: "DashboardLayout",
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    Widget
  },
  data: () => ({
    colNum: 2,
    widgetWidth: 1,
    widgetHeight: 5,
    loadedWidgets: 0,
    rowHeight: 20,
    margin: [10, 10],
    loading: true
  }),
  computed: {
    layout: {
      get() {
        return this.$store.getters["dashboardStore/getLayout"];
      }
    },
    layoutSorted: {
      get() {
        return [...this.$store.getters["dashboardStore/getLayout"]].sort(
          function(a, b) {
            let nameA = a.y * 100 + a.x;
            let nameB = b.y * 100 + b.x;
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          }
        );
      }
    }
  },
  methods: {
    saveLayout() {
      this.$store.dispatch("dashboardStore/set", { layout: this.layout });
    }
  },
  mounted() {
    this.$store.dispatch("dashboardStore/getLayout", {
      onSuccess: () => {
        this.loading = false;
      }
    });
  }
};
</script>

<style scoped></style>
